<template>
    <div id="listWorngGLAccount">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Wrong GL List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content gl-account-list">

                        <data-table-filter-config :moduleName="'wrongGlAccountsList'" ref="filterGlaccount" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'wrongGlAccountsList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listWrongGLAccountsTable"
                                      mode="remote"
                                      title="WrongGLAccounts"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                        enabled: gl_account_value,
                                        selectOnCheckboxOnly: true,  // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                        enabled: false,
                                      }"
                                      :sort-options="{
                                              enabled: true,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                      <router-link  title="Edit GLAccount" class="fp-edit" v-bind:to="{name: 'GLTransactionEdit',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                            <button v-if="gl_account_value" id="postGLAccountBtn" v-on:click.prevent="glTransactionStatus" class="btn btn-primary">Change Status</button>
                                            <button v-if="gl_account_value" id="postGLAccountBtn" v-on:click.prevent="glTransactionPost" class="btn btn-primary">Post</button>
                                            <!-- <button v-if="gl_account_value" id="deleteGLAccountBtn" v-on:click.prevent="glAccountDelete" class="btn btn-danger">Delete</button> -->
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';

export default {
    name: "wrongGlAccountsLink",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Wrong GL List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[contractMixins,commonMixins,dataTableMixins],
    data: () => ({
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                hidden:false,
                sortable: false,
            },
            {
                label: 'Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Transaction Number',
                field: 'transaction_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Transaction Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'description',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Year',
                field: 'year',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Year", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Period',
                field: 'period',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Period", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'User Create',
                field: 'created_by',
                fpFieldType:"text",
                filterable: true,
                hidden:false
            },
            {
                label: "Created Date",
                field: "created_at",
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "MM/DD/YYYY", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
                }
            },
          {
            label: 'Document Number',
            field: 'document_number',
            fpFieldType:"text",
            filterable: true,
            hidden:false
          },
          {
            label: 'Source',
            field: 'source',
            fpFieldType:"text",
            filterable: true,
            hidden:false
          },

        ],
        rows: [],
        accountTypesArr:[],
        totalRecords: 0,
        permissions:[],
        loading:false,
        action:"list",
        cantAccessPage:"",
        gl_account_value:false,
        canAddGl:false,
        canUpdateGl:false,
        assetActive:'active',
        equityActive:'',
        liabilitiesActive:'',
        revenueActive:'',
        suspenseActive:'',
        expenseActive:'',
        accountType:'',
        pageKey:"gl_transactions_list",
        firstLoad: 0,
        batchProcess:0,
        batchNum:"",
        filterAll:[],
    }),
    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'wrong_gl_list') {
                    self.cantAccessPage = true;
                    self.gl_account_value = true;
                    self.canUpdateGl = true;
                }
            });
        },

        accountTypesArr(typeArr) {

            this.$nextTick(() => {
                this.getGlAccounts(typeArr[0].value,0);
            });

        }
    },
    created: function() {
        var self = this;
    },
    mounted: function () {

        this.getPermissions();
        this.loadFieldData(['accountTypes']);
    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listWrongGLAccountsTable.unselectAllInternal();
          },

        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
        },
        getGlAccounts(acType,index) {

            //set active class
            $(".tab-buttons").removeClass("active");
            $("#tab_"+index).addClass("active");

            this.accountType = acType;
            if ( self.firstLoad == 1 ) {
            this.$refs.filterGlaccount.onColumnFilter('cancel');
            this.loadList();
            }
            self.firstLoad=1;
        },
        loadList() {
            var self = this;
            self.loading = true;
            var data = this.$refs['listWrongGLAccountsTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listWrongGLAccountsTable'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                all:self.serverParams.selectedAll,
                id:use,
                accountTypeId:self.accountType

            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/gl-account/gllist",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if (self.action == 'delete') {

                            self.action = "list";
                            self.$refs.filterGlaccount.clearSelectAll();

                            self.$swal('','GL account have been deleted successfully','success');
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();

                        } else {

                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (self.action =='export') {
                        self.generateStatusCodeMessage(jqXHR,true,'glaccount-export');
                    }else{
                        self.generateStatusCodeMessage(jqXHR,false,'glaccount-list');
                    }
                }
            });
        },
        glTransactionPost() {
            
            var self = this;

            var rowData = self.$refs['listWrongGLAccountsTable'].selectedRows;
            var glIdArr = [];


            for(var i = 0;i < rowData.length; i++){
                if(rowData[i].code == 'UUU'){
                    self.$swal('','You can only post records with status 999','info');
                    return;
                }
                glIdArr.push(rowData[i].id);
            }
            
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/gl-transaction/post",
                type: "POST",
                data: {arr:glIdArr,status:"999"},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    var message = [];
                    if (data.status == "success") {
                        self.$swal('','GL Transaction Posted Successfully.','success');
                        self.loadList();
                    } else if (data.status == "error"){
                        self.$swal('',data.content,'info');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'glaccount-create');
                }
            });
        },
        glTransactionStatus(){
            var self = this;
            var rowData = self.$refs['listWrongGLAccountsTable'].selectedRows;
            var glIdArr = [];


            for(var i = 0;i < rowData.length; i++){
                glIdArr.push(rowData[i].id);
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/gl-transaction/change-status",
                type: "POST",
                data: {arr:glIdArr,status:"999"},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    var message = [];
                    if (data.status == "success") {
                        self.$swal('','GL Transaction Status Updated Successfully.','success');
                        self.loadList();
                    } else if (data.status == "error"){
                        self.$swal('',data.content,'info');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'glaccount-create');
                }
            });
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/accounting/GLTransactionList.vue